import { DispatchWithoutAction, useMemo } from 'react'
import css from './placeholder.module.css'
import calculatePositionUtils from '../GridItem/calculatePosition.utils'
import { IActiveElement, TLayout, TPlaceholderParam, IPositionParams } from '../../grid.types'
import placeholderUtils from './placeholder.utils'
import gridLayoutUtils from '../../gridLayout.utils'

interface IProps {
  positionParams: IPositionParams
  activeElement: IActiveElement
  layout: TLayout

  forceUpdate: DispatchWithoutAction
}

const PlaceholderLayout = (props: IProps) => {
  const movingItem = useMemo(() => {
    if (!props.activeElement) return
    return props.layout.find((item) => item.key === props.activeElement.key)
  }, [props.layout, props.activeElement])

  const renderPlaceholderByParams = (params: TPlaceholderParam[]) => {
    return params.map((param) => (
      <div
        key={`${param.x}-${param.y}`}
        className={css.placeholder}
        data-active={param.active}
        style={{
          gridRow: param.y + 1,
          gridColumn: param.x + 1,
        }}
      ></div>
    ))
  }

  const renderPlaceholders = () => {
    if (!movingItem) return
    if (props.activeElement.movedType === 'resizing') {
      const activePlaceholderParams = placeholderUtils.calcPlaceholderParamsForEl(movingItem)
      return renderPlaceholderByParams(activePlaceholderParams)
    }
    const placeholdersParams = placeholderUtils.calcParamsForEachPlaceholderGridAtGrid(
      props.positionParams.cols,
      gridLayoutUtils.bottom(props.layout) + movingItem.height,
      movingItem
    )
    return renderPlaceholderByParams(placeholdersParams)
  }

  if (!props.positionParams.containerWidth) return null

  return (
    <div
      className={css.layout}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${props.positionParams.cols}, ${calculatePositionUtils.calcGridColWidth(props.positionParams)}px)`,
        gridAutoRows: `${props.positionParams.rowHeight}px`,
        rowGap: `${props.positionParams.margin[0]}px`,
        columnGap: `${props.positionParams.margin[1]}px`,
      }}
    >
      {props.activeElement && renderPlaceholders()}
    </div>
  )
}
export default PlaceholderLayout
